import React, { Suspense } from 'react';
import type { YouTubeProps } from 'react-youtube';

import ReactYoutube from './ReactYoutube.lazy';

const LazyYoutube = (props: YouTubeProps) => (
  <Suspense fallback={null}>
    <ReactYoutube data-testid="react-youtube" {...props} />
  </Suspense>
);

export default LazyYoutube;
